<section class="w-full">
  <header class="l-flex l-align-y l-align-spaceBetween handle">
    <h2 class="t-widgetTitle">
      {{ "translate.tasks.editTaskTitle" | translate }}
    </h2>
    <i class="fas fa-times t-popupCloseIcon" (click)="closePanel()"></i>
  </header>
  <hr />
</section>

<div *ngIf="task.msgId" class="chat-msg">
  <div class="message">
    <span> {{ task.msgTxt }}</span>
  </div>
  <div class="message-data">
    <span
      >{{ task.msgFromUserDescr }} /
      {{ task.msgTimestamp | date : "HH:mm - dd.MM.yyyy" }}</span
    >
  </div>
</div>

<div class="body-container">
  <div class="right-container">
    <section class="w-full">
      <div class="l-flex-column t-panel no-indent">
        <!--title-->
        <input-wrap
          [required]="true"
          label="{{ 'translate.tasks.title' | translate }}"
          cssClass="l-cell-spread"
        >
          <input
            type="text"
            [(ngModel)]="task.taskTitle"
            class="t-input t-input--colored"
          />
        </input-wrap>

        <!--owner-->
        <input-wrap
          *ngIf="!taskUsersList.loading"
          label="{{ 'translate.tasks.owner' | translate }}"
          cssClass="l-cell-spread"
          [loading]="taskUsersList && taskUsersList.loading"
          [required]="true"
        >
          <p-select
            class="t-input--colored"
            [options]="taskUsersList"
            [(ngModel)]="task.owner"
            [placeholder]="'translate.general.choose' | translate"
            optionLabel="label"
            [filter]="true"
            [resetFilterOnHide]="true"
            appendTo="body"
          ></p-select>
        </input-wrap>

        <!--due date-->
        <input-wrap label="{{ 'translate.tasks.dueDate' | translate }}">
          <p-datepicker
            class="t-input--colored p-append-top"
            dateFormat="dd/mm/yy"
            [(ngModel)]="task.dueDate"
            readonlyInput="readonlyInput"
            showButtonBar="true"
            placeholder="{{ 'translate.general.choose' | translate }}"
            appendTo="body"
          ></p-datepicker>
        </input-wrap>
      </div>
    </section>
  </div>

  <div class="left-container">
    <section class="w-full">
      <!--status-->
      <input-wrap
        label="{{ 'translate.general.statusDescr' | translate }}"
        cssClass="l-cell-spread"
        [loading]="statusList && statusList.loading"
      >
        <p-select
          class="t-input--colored"
          [options]="statusList"
          [(ngModel)]="task.status"
          [placeholder]="'translate.general.choose' | translate"
          [optionLabel]="'label'"
          appendTo="body"
        ></p-select>
      </input-wrap>

      <!--notes-->
      <input-wrap
        label="{{ 'translate.tasks.notes' | translate }}"
        cssClass="t-inputWrap-spread-y"
      >
        <textarea
          dir="auto"
          class="t-input t-input--colored l-cell-spread-y"
          [(ngModel)]="task.notes"
          cssClass="w-full"
        ></textarea>
      </input-wrap>
    </section>
  </div>
</div>

<div class="bottom-container">
  <!--info-->
  <div class="task-info">
    <p *ngIf="task.createTimestamp">
      {{ "translate.tasks.createdAt" | translate }}
      <span>{{ task.createTimestamp }}</span>
      {{ "translate.tasks.createdBy" | translate }}
      <span>{{ task.createUserDescr }}</span>
    </p>
    <p *ngIf="task.lastUpdTimestamp">
      {{ "translate.tasks.updatedAt" | translate }}
      <span>{{ task.lastUpdTimestamp }}</span>
      {{ "translate.tasks.updatedBy" | translate }}
      <span>{{ task.lastUpdUserDescr }}</span>
    </p>
  </div>

  <div class="action-container t-buttonSet l-align-end">
    <spinner *ngIf="saving"></spinner>
    <button
      [disabled]="saving || !saveEnabled()"
      (click)="save()"
      class="t-button-outline"
    >
      {{ "translate.general.save" | translate }}
    </button>
  </div>
</div>
